<template>
  <div class="add_card_container">
    <div class="add_card_container--inputs">
      <InputText
        label='Alias de la tarjeta'
        placeholder='Ej. Visa personal'
        v-model='alias'
        missingErrorMessage='Ingresa un alias para la tarjeta.'
        :showEmptyInputError='tryToSubmit && !alias'
        :showExtraMessage="true"
        extraMessage='Los datos de tu tarjeta serán solicitados de forma segura por Izipay.'
      />
      <div id="izipay-form-container"></div>
    </div>

    <div class='add_card_container--buttons'>
      <ButtonDefinitive
        label="Continuar con Izipay"
        @click="registerCardWithIzipay()"
      />
      <ButtonDefinitive
        variant='tertiary'
        label="Cancelar"
        @click="setSection('list')"
      />
    </div>
  </div>
</template>

<script>
import ButtonDefinitive from '@/components/Button/ButtonDefinitive.vue'
import InputText from '@/components/Form/InputText.vue'
import { loadIzipaySdk, getIzipaySession, confirmIzipayCard } from '../../services/izipay'

export default {
  name: "AddEditCard",
  components: { ButtonDefinitive, InputText },
  data() {
    return {
      alias: "",
      tryToSubmit: false,
    };
  },
  methods: {
    setSection(value) {
      this.$store.dispatch("HELPER_SET_CURRENT_CARD_SECTION", value);
    },
    async fetchCards() {
      this.showLoading();
      await this.$store
        .dispatch("GET_CARDS")
        .then((success) => {
          this.$swal.close();
          if (success.status === 200) {
            const cards = success.data.result;
            this.$store.dispatch("GENERAL_SET_CARDS", cards);
          } else {
            this.showError(success.data.message);
          }
        })
        .catch((error) => {
          const msg = error?.data?.message || "Ocurrio un error.";
          this.showError(msg);
        });
    },

    async registerCardWithIzipay() {
      this.tryToSubmit = true;
      if (!this.alias) return;

      try {
        this.showLoading();
        const session = await getIzipaySession();
        await loadIzipaySdk();
        this.$swal.close();

        document.getElementById('izipay-form-container').innerHTML = '';

        // eslint-disable-next-line no-undef
        const izi = new Izipay({
          config: {
            transactionId: session.transactionId,
            action: 'register',
            merchantCode: session.merchantCode,
            order: {
              orderNumber: session.orderNumber,
              currency: 'PEN',
              amount: '0.00',
              payMethod: 'CARD',
              processType: 'AT',
              // merchantBuyerId: String(this.user.id),
              merchantBuyerId: '0'.repeat(8 - String(this.user.id).length) + this.user.id,
              dateTimeTransaction: Date.now().toString(),
            },
            billing: this.billingFromUser(),
            render: {
              typeForm: Izipay.enums.typeForm.POP_UP,
              container: '#izipay-form-container',
              showButtonProcessForm: true,
            },
          },
        });

        izi.LoadForm({
          authorization: session.authorization,
          keyRSA: session.publicKey,
          callbackResponse: (response) => this.onCardRegistered(response),
        });
      } catch (error) {
        this.$swal.close();
        this.showError(error.message || "Ocurrió un error interno al agregar la tarjeta");
      }
    },

    async onCardRegistered(response) {
      try {
        this.showLoading();
        const result = await confirmIzipayCard({ ...response, alias: this.alias });
        this.$swal.close();
        this.showOk("¡Tarjeta agregada con éxito!", () => {
          this.setSection('list');
          this.fetchCards();
        });
      } catch (error) {
        this.$swal.close();
        this.showError(error.message);
      }
    },

    billingFromUser() {
      return {
        firstName: this.user.name || 'Cliente',
        lastName: this.user.firstLastName || 'SAIO',
        email: this.user.email || 'cliente@saio.pe',
        phoneNumber: this.user.celular || '999999999',
        street: 'Av. Principal 123',
        city: 'Lima',
        state: 'Lima',
        country: 'PE',
        postalCode: '15001',
        document: this.user.nroDocumento || '00000000',
        documentType: 'DNI',
      };
    },
  },
  computed: {
    currentCardSection: {
      get() {
        return this.$store.getters.HELPER_CURRENT_CARD_SECTION;
      },
      set(value) {
        this.$store.dispatch("HELPER_SET_CURRENT_CARD_SECTION", value);
      },
    },
    currentCardToEdit() {
      return this.$store.getters.HELPER_CURRENT_CARD_TO_EDIT;
    },
    user() {
      return this.$store.getters.USER;
    },
  },
};
</script>

<style scoped lang='scss'>
.add_card_container {
  height: 88%;
  overflow-y: auto;
  padding: 32px 20px;

  &--inputs {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  &--buttons {
    padding-top: 32px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}
</style>
